export class Buttons {
  btncrear = {
    text: "Crear",
    status: true,
    style: "btn-light ",
    ico: "bi bi-plus-circle",
    carga: false
  }


  btnGuardar = {
    text: "Guardar",
    status: true,
    style: "btn-light",
    ico: "bi bi-check2-circle",
    carga: false
  }

  btncancelar = {
    text: "Cancelar",
    status: true,
    style: "btn-light",
    ico: "bi bi-x-circle",
    carga: false
  }

  btndefault = {
    text: "",
    status: false,
    style: "",
    ico: "",
    carga: false
  }


  /*       constructor(btncrear, btnGuardar,btncancelar) {
  
      
      this.documentUser = documentUser;
      this.user = user;
      this.index = this.documentUser.findIndex(
        (users) => users.email === this.user
      );
    }
   */


}
